import { concatValuesBy } from '@miq/utils';
import { map } from 'rxjs/operators';
import { ReportRecord } from '../../../../models/report.model';
import { LovValues, DisplayFunctionOptions, VisibilitySettings } from '../../../../models/template.model';
import { currencyLov, PropertyType, valueWithUomPrefix, extraCurrencyValues } from '../us/us.common';
import { digger } from '@cbre/digger';

function getMinMaxAskingRateMonthly(
  record: ReportRecord,
  options: DisplayFunctionOptions,
  askingRateMin,
  askingRateMax
) {
  return currencyLov(options).pipe(
    map((currencyLOV: LovValues[]) => {
      /*
       * prepare and add extra currencies as we currently do not have
       * swedish or norwegian currency symbols.
       */
      currencyLOV.push(...extraCurrencyValues);
      const minRate = valueWithUomPrefix(record, PropertyType.Office, askingRateMin, currencyLOV);
      const maxRate = valueWithUomPrefix(record, PropertyType.Office, askingRateMax, currencyLOV);
      let minRateVal = minRate;
      if (Array.isArray(minRate)) {
        minRateVal = minRate.join('-');
      }
      let maxRateVal = maxRate;
      if (Array.isArray(maxRate)) {
        maxRateVal = maxRate.join('-');
      }
      if (minRateVal === '-' && maxRateVal === '-') {
        return '-';
      }

      return concatValuesBy(' - ', minRateVal, maxRateVal);
    })
  );
}

function getMinMaxAskingRateMonthlyVisibility(record: ReportRecord, settings: VisibilitySettings): boolean {
  const { field } = settings;
  if (!field) {
    return false;
  }
  const askingRentField = field.displayFnArguments ?? null;
  const filteredRents = askingRentField.filter(displayFnArg => displayFnArg.field != null);
  if (Array.isArray(askingRentField) && filteredRents.length > 0) {
    const askingRateVals = filteredRents.map(displayFn => digger(record.data, displayFn.field));
    const filteredVals = askingRateVals.filter(val => (Array.isArray(val) ? val[0] !== null : val !== null));
    const flattedFilteredVals = [].concat(...filteredVals);
    if (flattedFilteredVals.length === 0) {
      return true;
    }
    if (flattedFilteredVals.length === 2) {
      return !(flattedFilteredVals[0] === flattedFilteredVals[1]);
    }
  }
  return false;
}

export const emeaMinMaxAskingRateFunctions = {
  358: {
    // 358 - min - max asking rate (Poland)
    displayFn: getMinMaxAskingRateMonthly,
    isVisible: getMinMaxAskingRateMonthlyVisibility,
  },
  463: {
    // 463 - min - max asking rate (Finland)
    displayFn: getMinMaxAskingRateMonthly,
    isVisible: getMinMaxAskingRateMonthlyVisibility,
  },
  377: {
    // 377 - min - max asking rate (Italy)
    displayFn: getMinMaxAskingRateMonthly,
    isVisible: getMinMaxAskingRateMonthlyVisibility,
  },
  892: {
    // 892 - Min - Max Direct Asking Rate Yearly (Norway, Netherlands, Sweden)
    displayFn: getMinMaxAskingRateMonthly,
    isVisible: getMinMaxAskingRateMonthlyVisibility,
  },
};
